import React, { FC } from 'react';
import { Element } from 'react-scroll';
import { HomeSearchContainer } from '../modules/home-search/home-search.container';
import { RelevantServicesContainer } from '../modules/relevant-services/relevant-services.container';
import { NewsContainer } from '../modules/news/news.container';
import { FooterContainer } from '../modules/footer/footer.container';
import { IndicatorsContainer } from '../modules/indicators/indicators.container';
import { ServicesContainer } from '../modules/services/services.container';
import { Button } from '@plataformaxvia/design-system';
import { useHistory } from 'react-router-dom';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export const Home: FC = () => {
  let history = useHistory();
  return (
    <>
      <h1 className="visually-hidden">Portal de Serviços de Pernambuco</h1>
      
      <section id="home-search">
        <Element name="HomeSearch">
          <HomeSearchContainer />
        </Element>
      </section>

      <section id="relevant-services">
        <Element name="RelevantServices">
          <RelevantServicesContainer />
        </Element>
      </section>

      <section id="news-container">
        <Element name="newsContainer">
          <NewsContainer />
        </Element>
      </section>

      <section id="indicators">
        <Element name="indicators">
          <IndicatorsContainer />
        </Element>
      </section>

      <section id="list-services">
        <Element name="services">
          <ServicesContainer
            title="Serviços disponíveis"
            element={
              <Button
                iconEnd={<ArrowRightAltIcon />}
                label="Mais serviços"
                onClick={() => history.push('carta-de-servicos')}
                aria-label="Mais serviços"
                variant="primary"
                size="small"
              />
            }
          />
        </Element>
      </section>
      
      <footer>
        <FooterContainer />
      </footer>
    </>
  );
};
